import { Button, Modal } from '@comptia-sso/core';
import { ReactElement } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import styles from './LinkedSuccessfullyModal.module.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const LinkedSuccessfullyModal = ({
  isOpen,
  onClose,
}: Props): ReactElement => {
  const { t } = useTranslation();

  return (
    <Modal
      open={isOpen}
      title={t('LinkedSuccessfullyModal.Title')}
      onClose={onClose}
    >
      <p>{t('LinkedSuccessfullyModal.Linked')}</p>
      <p>
        <Trans
          i18nKey="LinkedSuccessfullyModal.Use"
          components={{
            linktag: (
              <a href={process.env.REACT_APP_COMPTIA_CENTRAL_LOGIN as string} />
            ),
          }}
        />
      </p>
      <p>
        <Trans
          i18nKey="LinkedSuccessfullyModal.Issue"
          components={{
            linktag: (
              <a target="_blank" rel="noreferrer" href={t('Links.Support')} />
            ),
          }}
        />
      </p>
      <div className={styles.buttons}>
        <Button onClick={onClose}>
          {t('LinkedSuccessfullyModal.Continue')}
        </Button>
      </div>
    </Modal>
  );
};
